module.exports = __webpack_public_path__ + "static/media/Landline_Icon.f146891c.svg";